import {invalidateQueries, q} from "../../../state";
import {
  ComplexityModel,
  ComplexityModelId,
  ComplexityModelMin,
  CreateComplexityModel,
  UpdateComplexityModelName,
} from "platformed-client/types";
import {platformedClient} from "../..";

/**
 * List all complexity models
 */
export async function list(): Promise<ComplexityModelMin[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/complexity/list", {});
}

/**
 * Get a specific complexity model by ID
 */
export async function get_(modelId: ComplexityModelId): Promise<ComplexityModel> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/complexity/{model_id}", {
    path: {model_id: modelId},
  });
}

/**
 * Create a new complexity model
 */
export async function create(model: CreateComplexityModel): Promise<ComplexityModelId> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/complexity", {body: model});
  await invalidateQueries([q.tprm.complexityModels.filter()]);
  return res;
}

/**
 * Update the name of a complexity model
 */
export async function updateName(modelId: ComplexityModelId, update: UpdateComplexityModelName) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/complexity/{model_id}/name", {
    path: {model_id: modelId},
    body: update,
  });
  await invalidateQueries([q.tprm.complexityModels.filter(), q.tprm.complexityModel.filter(modelId)]);
  return res;
}

/**
 * Delete a complexity model
 */
export async function delete_(modelId: ComplexityModelId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/complexity/{model_id}", {
    path: {model_id: modelId},
  });
  await invalidateQueries([q.tprm.complexityModels.filter(), q.tprm.complexityModel.filter(modelId)]);
  return res;
}
